import i18n from '@app/dashboard/tools/i18n';
import type {
  LinkStates,
  OrderStatus,
} from './../../../../types/innerLayout/orders/index';

const { t } = i18n;

export const getOrderStatus = (state: string): string => {
  const LINK_STATES: LinkStates = {
    PAID: 'PAID',
    UNPAID: 'UNPAID',
    CANCELLED: 'CANCELED',
  };

  const statusMap: Record<string, OrderStatus> = {
    [LINK_STATES.PAID]: {
      text: t('innerLayout.ordersPage.statuses.paid'),
      className: 'successLable',
    },
    [LINK_STATES.UNPAID]: {
      text: t('innerLayout.ordersPage.statuses.unpaid'),
      className: 'pendingLable',
    },
    [LINK_STATES.CANCELLED]: {
      text: t('innerLayout.ordersPage.statuses.cancelled'),
      className: 'cancelLable',
    },
  };

  const status = statusMap[state] || statusMap[LINK_STATES.UNPAID];

  return status.text;
};
